export default __webpack_public_path__ + "static/media/big_robot_isometric_and_above.e6d8bd8b.jpg";